import Button from "../../../common/components/input/Button/Button";
import { TabletopCanvasInputContext } from "../controls/TabletopCanvasInputContext";
import { useContext } from "react";

import gridVisibleIcon from "../../../assets/images/common/png/grid_visible.png";
import gridSnapIcon from "../../../assets/images/common/png/grid_snap.png";

export default function TabletopWorkspaceSettingsBar(props: {}): React.ReactElement {
    const { state: canvasInputState, setState: setCanvasInputState } =
        useContext(TabletopCanvasInputContext);

    return (
        <div style={{ width: 80 }}>
            <Button
                color={canvasInputState.gridVisible ? "active" : "neutral"}
                icon={gridVisibleIcon}
                onClick={() => {
                    setCanvasInputState({
                        ...canvasInputState,
                        gridVisible: !canvasInputState.gridVisible,
                    });
                }}
                tooltip="Show Grid"
            />
            <Button
                color={canvasInputState.snapToGrid ? "active" : "neutral"}
                icon={gridSnapIcon}
                onClick={() => {
                    setCanvasInputState({
                        ...canvasInputState,
                        snapToGrid: !canvasInputState.snapToGrid,
                    });
                }}
                tooltip="Snap To Grid"
            />
        </div>
    );
}
